import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import { IsSmallScreen } from "../../commonFunctions/CommonFunctions";
import WSBottomNav from "../AppBar/WSAppBar";
import { Home, ContactPhone, Leaderboard } from "@mui/icons-material";
import Navbar2 from "./Navbar2";
import Sidebar2 from "./Sidebar2";

const DashboardLayout: React.FC = () => {
  // Define color variables
  const primaryColor = "#3D52A0";
  const secondaryColor = "#516F90";
  const hoverColor = "#23255a";
  const iconColor = "#4a4b77";
  const textColor = "#d1d5db";
  const hoverTextColor = "#fff";
  const backgroundColor = "#0b1a36";
  const selectedBackgroundColor = "#7091E6";
  const boxShadowColor = "rgba(209, 200, 200, 0.6)";

  const isMobile = IsSmallScreen();

  const [open, setOpen] = useState(true);
  const [collapse, setCollapse] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const myNavItems = [
    { path: "/home", icon: <Home />, label: "Home" },
    { path: "/leads/list", icon: <Leaderboard />, label: "Leads" },
    { path: "/contacts/list", icon: <ContactPhone />, label: "Contact" }
  ];

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {!isMobile && (
        <Navbar2
          anchorEl={anchorEl}
          collapse={collapse}
          backgroundColor={backgroundColor}
        />
      )}

      <Sidebar2
        collapse={collapse}
        handleCollapse={handleCollapse}
        handleDrawerToggle={handleDrawerToggle}
        open={open}
        // bellow for color changes
        backgroundColor={backgroundColor}
        boxShadowColor={boxShadowColor}
        hoverColor={hoverColor}
        hoverTextColor={hoverTextColor}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        selectedBackgroundColor={selectedBackgroundColor}
        textColor={textColor}
        iconColor={iconColor}
      />

      {/* Main Content */}
      <Box
        sx={{
          flexGrow: 1,
          marginTop: !isMobile ? "5rem" : "0.7rem", // Offset for AppBar height
          overflowY: "auto", // Enable scrolling for content only
          marginLeft: isMobile ? "0rem" : collapse ? "5rem" : "15rem",
          // marginBottom: isMobile ? "0rem" : collapse ? "5rem" : "15rem"
        }}
      >
        <div style={{ padding: 10 }}>
          <Outlet />
        </div>
      </Box>

      {isMobile && <WSBottomNav navigationItems={myNavItems} />}
    </Box>
  );
};

export default DashboardLayout;
